export const GET_ALL_PRODUCT_TAGS = 'GET_ALL_PRODUCT_TAGS'
export const GET_ALL_PRODUCT_TAGS_SUCCESS = 'GET_ALL_PRODUCT_TAGS_SUCCESS'
export const CREATE_PRODUCT_TAG = 'CREATE_PRODUCT_TAG'
export const CREATE_PRODUCT_TAG_SUCCESS = 'CREATE_PRODUCT_TAG_SUCCESS'
export const UPDATE_PRODUCT_TAG = 'UPDATE_PRODUCT_TAG'
export const UPDATE_PRODUCT_TAG_SUCCESS = 'UPDATE_PRODUCT_TAG_SUCCESS'
export const DELETE_PRODUCT_TAG = 'DELETE_PRODUCT_TAG'
export const DELETE_PRODUCT_TAG_SUCCESS = 'DELETE_PRODUCT_TAG_SUCCESS'